var _rect, _ellipse, _g, _g2, _rect2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 114,
    rx: 57,
    fill: "#2F1E3B",
    fillOpacity: 0.21
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59,
    cy: 57,
    rx: 43,
    ry: 41,
    fill: "#2F1E3B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint0_linear_486_1528)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 47,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint1_linear_486_1528)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 47,
    width: 21,
    height: 21,
    fill: "url(#pattern0)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 86,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint2_linear_486_1528)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 59,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint3_linear_486_1528)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 68,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint4_linear_486_1528)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 44,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint5_linear_486_1528)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 48,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint6_linear_486_1528)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 85,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint7_linear_486_1528)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 78,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint8_linear_486_1528)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 91,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint9_linear_486_1528)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 20,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint10_linear_486_1528)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 44,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint11_linear_486_1528)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint12_linear_486_1528)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 31,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint13_linear_486_1528)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_486_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 68,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint14_linear_486_1528)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_486_1528",
    x: 41,
    y: 29,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_486_1528",
    x: 93,
    y: 46,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_486_1528",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_486_1528",
    x: 63,
    y: 85,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_486_1528",
    x: 26.5,
    y: 58.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_486_1528",
    x: 35.5,
    y: 67.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_486_1528",
    x: 34.5,
    y: 43.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_486_1528",
    x: 81.5,
    y: 47.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_486_1528",
    x: 76.5,
    y: 84.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_486_1528",
    x: 36.5,
    y: 77.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_486_1528",
    x: 51.5,
    y: 90.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_486_1528",
    x: 58.5,
    y: 19.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_486_1528",
    x: 73.5,
    y: 43.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_486_1528",
    x: 29.5,
    y: 29.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_486_1528",
    x: 68,
    y: 30,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_486_1528",
    x: 80,
    y: 67,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1528",
    x1: 42.5,
    y1: 30,
    x2: 42.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1528",
    x1: 94.5,
    y1: 47,
    x2: 94.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1528",
    x1: 64.5,
    y1: 86,
    x2: 64.5,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1528",
    x1: 27.5,
    y1: 59,
    x2: 27.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1528",
    x1: 36.5,
    y1: 68,
    x2: 36.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1528",
    x1: 35.5,
    y1: 44,
    x2: 35.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1528",
    x1: 82.5,
    y1: 48,
    x2: 82.5,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1528",
    x1: 77.5,
    y1: 85,
    x2: 77.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1528",
    x1: 37.5,
    y1: 78,
    x2: 37.5,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1528",
    x1: 52.5,
    y1: 91,
    x2: 52.5,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1528",
    x1: 59.5,
    y1: 20,
    x2: 59.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_1528",
    x1: 74.5,
    y1: 44,
    x2: 74.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_486_1528",
    x1: 30.5,
    y1: 30,
    x2: 30.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_486_1528",
    x1: 69.5,
    y1: 31,
    x2: 69.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_486_1528",
    x1: 81.5,
    y1: 68,
    x2: 81.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_486_1528",
    width: 512,
    height: 512,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5f7263c04b9f8f619805f272e8e8c47f.svg";
export { ForwardRef as ReactComponent };